import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import BudgetDetailPageUI from './BudgetDetailPageUI.js'

class BudgetDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      order: null,
      budget: null,
      itemList: null,
      filteredItemList: null,
      searchFilter: '',
      requestFundMode: false,
      updateBudgetMode: false
    }
  }

  render() {
    return (
      <BudgetDetailPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        order={this.state.order}
        budget={this.state.budget}
        itemList={this.state.itemList}
        filteredItemList={this.state.filteredItemList}
        requestFundMode={this.state.requestFundMode}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onRequestFundClick={() => { this.setState({requestFundMode: true}) }}
        onRequestFundCancel={() => { this.setState({requestFundMode: false}) }}
        onRequestFundComplete={this.onRequestFundComplete}
        onSearchFilterChange={this.onSearchFilterChange}
        // update modal
        updateBudgetMode={this.state.updateBudgetMode}
        onUpdateBudgetClick={(event) => { this.setState({updateBudgetMode: true}) }}
        onCancelUpdateBudget={(event) => { this.setState({updateBudgetMode: false}) }}
        onUpdateBudgetComplete={this.onUpdateBudgetComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getBudget(context)
    this.getBudgetItems(context)
    this.getMessages(context)
    Modal.setAppElement('body')
  }

  getOrder(context, orderId) {
    let cacheManager = new CacheManager({
      resource: `/api/orders/${orderId}`,
      cacheKey: CacheKeys.Order(orderId),
      callback: this.getOrderCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      order: response.order,
    })
  }

  getBudget(context) {
    let cacheManager = new CacheManager({
      resource: `/api/budgets/${this.props.match.params.budgetId}`,
      cacheKey: CacheKeys.Budget(this.props.match.params.budgetId),
      callback: this.getBudgetCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBudgetCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      budget: response.budget,
    })
    if (response.budget != null)
      this.getOrder(this.props.context, response.budget.customerOrderId)
  }

  getBudgetItems(context) {
    let cacheManager = new CacheManager({
      resource: `/api/budgets/${this.props.match.params.budgetId}/budgetItems`,
      cacheKey: CacheKeys.BudgetItems(this.props.match.params.budgetId),
      callback: this.getBudgetItemsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBudgetItemsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.BudgetItemsFilter(this.props.match.params.budgetId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      itemList: response.budgetItemList,
      filteredItemList: response.budgetItemList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.budgetItemList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(itemList, searchFilter) {
    let filteredList = itemList

    if (searchFilter)
      filteredList = filteredList.filter(item =>
        item.itemName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({filteredItemList: filteredList})

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.BudgetItemsFilter(this.props.match.params.budgetId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Order(this.state.order.orderId))
    CacheManager.removeObject(CacheKeys.Budget(this.props.match.params.budgetId))
    CacheManager.removeObject(CacheKeys.BudgetItems(this.props.match.params.budgetId))
    this.setState({
      errorList: null,
      itemList: null,
      filteredItemList: null,
      budget: null,
      order: null
    }, () => {
      this.getBudget(context)
      this.getBudgetItems(context)
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.itemList, searchFilter)
  }

  onRequestFundComplete = (budget) => {
    CacheManager.removeObject(CacheKeys.Budget(this.props.match.params.budgetId))
    this.setState({ budget: budget })
    setTimeout(() => {
      this.setState({ requestFundMode: false })
    }, 2000)
  }

  onUpdateBudgetComplete = (budget) => {
    CacheManager.removeObject(CacheKeys.Budget(this.props.match.params.budgetId))
    CacheManager.removeObject(CacheKeys.OrderBudgets(budget.customerOrderId))
    this.setState({ budget: budget })
    setTimeout(() => {
      this.setState({ updateBudgetMode: false })
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_refresh',
      'c_add_bdg_item',
      'c_no_item_msg',
      'c_allocated',
      'c_utilized',
      'c_budget',
      'c_qty',
      'c_due_date',
      'c_status_done',
      'c_request_fund',
      'c_completion_date',
      'c_request_amount',
      'c_request_date',
      'c_required_by',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_budget', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(BudgetDetailPageSF)
